import { useExperimentBucket } from '@carvana/experiment';
import { useClientSide } from '@carvana/merch-react-hooks';
import { clientSideUserIdExperiments } from '~/constants/common/experiments';
import { Experiments } from '~/contracts/common';

export default function useIsInExperiment(
  name: keyof Experiments,
  bucket: string
) {
  const assignedBucket = useExperimentBucket(name);
  const isClientSide = useClientSide();

  return name in clientSideUserIdExperiments && !isClientSide
    ? false
    : assignedBucket === bucket;
}
